import PropTypes from 'prop-types';
import arkkeoLogo from '../../../../assets/img/arkkeo-logo.svg';
import { AppStoreIcon } from '../../../../components/Icons/AppStoreIcon';
import { PlayStoreIcon } from '../../../../components/Icons/PlayStoreIcon';
import { ModalWithTopLogo } from '../../../../components/Modals/ModalWithTopLogo';
import EventSender, {
  OfferShopInStoreAndroidStoreClickedEvent,
  OfferShopInStoreIosStoreClickedEvent,
} from '../../../../services/trackevent';
import styles from './BlockBamOffer.module.css';

export const BlockBamOfferModal = ({
  isOpen,
  closeModal,
  title,
  description,
  offerId,
  merchantId,
  clusterId,
  seasonCampaignId,
}) => {
  const onAppStoreClicked = () => {
    EventSender.sendEvent(
      OfferShopInStoreIosStoreClickedEvent(
        clusterId,
        merchantId,
        offerId,
        seasonCampaignId,
      ),
    );
  };
  const onPlayStoreClicked = () => {
    EventSender.sendEvent(
      OfferShopInStoreAndroidStoreClickedEvent(
        clusterId,
        merchantId,
        offerId,
        seasonCampaignId,
      ),
    );
  };
  return (
    <ModalWithTopLogo
      isOpen={isOpen}
      closeModal={closeModal}
      logo={arkkeoLogo}
      hasCloseButton>
      <h4 className={styles.title}>{title}</h4>
      <p className={styles.description}>{description}</p>
      <div className={styles.iconContainer}>
        <AppStoreIcon
          customClass={styles.appStoreContainer}
          onClick={onAppStoreClicked}
        />
        <PlayStoreIcon
          customClass={styles.playStoreContainer}
          onClick={onPlayStoreClicked}
        />
      </div>
    </ModalWithTopLogo>
  );
};
BlockBamOfferModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  offerId: PropTypes.string.isRequired,
  merchantId: PropTypes.string.isRequired,
  clusterId: PropTypes.string.isRequired,
  seasonCampaignId: PropTypes.string,
};
